import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Lock, Database } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-6"
        >
          <ArrowLeft size={20} />
          Rudi Nyuma
        </Link>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <Shield className="text-blue-600" size={32} />
            <h1 className="text-3xl font-bold text-slate-900">
              Sera ya Faragha
            </h1>
          </div>

          <div className="prose prose-slate max-w-none">
            <p className="text-sm text-slate-500 mb-6">
              Tarehe ya mwisho ya kusasisha: 15 Oktoba 2026
            </p>

            <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
              <div className="flex items-start gap-3">
                <Lock className="text-green-600 flex-shrink-0 mt-1" size={24} />
                <div>
                  <h3 className="font-semibold text-green-900 mb-2">
                    Ahadi Yetu: "Usiri ni Mtakatifu"
                  </h3>
                  <p className="text-green-800">
                    Video yako haipandi server kamwe. Kila kitu kinafanyika 100% local kwenye device yako. Tunaheshimu faragha yako.
                  </p>
                </div>
              </div>
            </div>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                1. Taarifa Tunazokusanya
              </h2>
              
              <h3 className="text-lg font-semibold text-slate-800 mb-2">
                Taarifa za Akaunti:
              </h3>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
                <li>Jina kamili</li>
                <li>Email address</li>
                <li>Namba ya simu (kwa malipo)</li>
                <li>Device fingerprint (kuzuia account sharing)</li>
              </ul>

              <h3 className="text-lg font-semibold text-slate-800 mb-2">
                Taarifa za Malipo:
              </h3>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
                <li>Historia ya malipo (tarehe, kiasi, status)</li>
                <li>Order IDs kutoka HarakaPay</li>
                <li>Hakuna taarifa za benki au card zinazohifadhiwa kwetu</li>
              </ul>

              <h3 className="text-lg font-semibold text-slate-800 mb-2">
                Taarifa za Matumizi:
              </h3>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
                <li>IP address (kwa security)</li>
                <li>Browser type na version</li>
                <li>Pages unazotembelea</li>
                <li>Muda wa kutumia huduma</li>
              </ul>

              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <h3 className="text-lg font-semibold text-red-900 mb-2">
                  ❌ HATUTUKUSANYI:
                </h3>
                <ul className="list-disc list-inside text-red-800 space-y-2">
                  <li>Video files zako (hakuna upload kamwe)</li>
                  <li>Audio files</li>
                  <li>Transcripts kama hujazisync kwa hiari</li>
                  <li>Location data (isipokuwa IP address kwa security)</li>
                  <li>Taarifa za kibinafsi zisizohitajika</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                2. Jinsi Tunavyotumia Taarifa
              </h2>
              <p className="text-slate-700 mb-3">Tunatumia taarifa kwa:</p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>Kutoa na kuendesha huduma</li>
                <li>Kuchakata malipo na subscriptions</li>
                <li>Kuzuia fraud na account sharing</li>
                <li>Kuboresha huduma zetu</li>
                <li>Kutumia mawasiliano kuhusu account yako</li>
                <li>Kulingana na sheria na regulations</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                3. Kugawana Taarifa
              </h2>
              <p className="text-slate-700 mb-3">
                <strong>Hatugawani taarifa zako</strong> na wahusika wa tatu isipokuwa:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li><strong>HarakaPay:</strong> Namba ya simu kwa malipo (tu unapochagua kulipia)</li>
                <li><strong>Cloudflare:</strong> Infrastructure provider (data imeencrypt)</li>
                <li><strong>Sheria:</strong> Kama tunahitajika kisheria</li>
              </ul>
              <p className="text-slate-700">
                Hatuuzi taarifa zako kwa wahusika wa tatu.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                4. Usalama wa Data
              </h2>
              <p className="text-slate-700 mb-3">Tunatumia:</p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li>HTTPS/TLS encryption kwa data in transit</li>
                <li>Encryption at rest kwa data kwenye database</li>
                <li>JWT tokens kwa authentication (24hrs expiry)</li>
                <li>Rate limiting kuzuia brute force attacks</li>
                <li>Input validation kuzuia SQL injection na XSS</li>
                <li>Device fingerprinting kuzuia unauthorized access</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                5. Video Processing - 100% Local
              </h2>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                <div className="flex items-start gap-3">
                  <Database className="text-blue-600 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h3 className="font-semibold text-blue-900 mb-2">
                      Usindikaji wa Video Kwenye Device Yako
                    </h3>
                    <p className="text-blue-800 mb-3">
                      Video yote inafanyika kwenye browser au desktop app yako:
                    </p>
                    <ul className="list-disc list-inside text-blue-800 space-y-1">
                      <li>FFmpeg.WASM inafanya processing kwenye browser</li>
                      <li>Whisper.WASM inafanya transcription kwenye browser</li>
                      <li>Hakuna video data inatumwa kwenda server</li>
                      <li>Metadata tu (transcript) inaweza kusync kwa hiari</li>
                      <li>Unamiliki video yako kabisa</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                6. Haki Zako
              </h2>
              <p className="text-slate-700 mb-3">Una haki ya:</p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li><strong>Kufikia:</strong> Kuomba nakala ya data zako</li>
                <li><strong>Kurekebisha:</strong> Kusasisha taarifa zisizo sahihi</li>
                <li><strong>Kufuta:</strong> Kuomba data zako zifutwe</li>
                <li><strong>Kupinga:</strong> Kukataa processing ya data zako</li>
                <li><strong>Data portability:</strong> Kupeleka data zako kwa service nyingine</li>
              </ul>
              <p className="text-slate-700">
                Kwa kuomba haki hizi, wasiliana nasi kupitia email.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                7. Cookies na Tracking
              </h2>
              <p className="text-slate-700 mb-3">Tunatumia:</p>
              <ul className="list-disc list-inside text-slate-700 space-y-2 mb-3">
                <li><strong>Essential cookies:</strong> Kwa authentication na security</li>
                <li><strong>Local storage:</strong> Kuhifadhi session data</li>
                <li><strong>Device fingerprint:</strong> Kuzuia account sharing</li>
              </ul>
              <p className="text-slate-700">
                Hatutumii tracking cookies za advertising au analytics za wahusika wa tatu.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                8. Kuhifadhi Data
              </h2>
              <p className="text-slate-700 mb-3">
                Tunahifadhi data yako muda wote ambao akaunti yako iko active. Kama utafuta akaunti yako, data itafutwa ndani ya siku 30.
              </p>
              <p className="text-slate-700">
                Baadhi ya data inaweza kuhifadhiwa kwa muda mrefu kama inahitajika kisheria au kwa legitimate business purposes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                9. Watoto
              </h2>
              <p className="text-slate-700">
                Huduma hii haikusudiwi kwa watoto chini ya miaka 18. Hatujui kwa makusudi tunakusanya taarifa kutoka kwa watoto.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                10. Mabadiliko ya Sera Hii
              </h2>
              <p className="text-slate-700 mb-3">
                Tunaweza kusasisha sera hii wakati wowote. Mabadiliko yatachapishwa hapa na tarehe ya mwisho ya kusasisha itaonyeshwa juu.
              </p>
              <p className="text-slate-700">
                Tunapendekeza ukague sera hii mara kwa mara ili kuwa informed kuhusu jinsi tunavyolinda data zako.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">
                11. Wasiliana Nasi
              </h2>
              <p className="text-slate-700 mb-3">
                Kwa maswali kuhusu sera hii au haki zako:
              </p>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li>Email: admin@clipgov.com</li>
                <li>Website: https://clip.wananchi.tv.tz</li>
              </ul>
            </section>

            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mt-8">
              <p className="text-sm text-slate-600 text-center">
                kwa kutumia CLIPD, unakubali sera hii ya faragha. Kama hukubali, tafadhali usitumie huduma hii.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
